"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useMemo } from "react";
import dynamic from "next/dynamic";
import { BrandedHeader } from "@/components/branded/headers/BrandedHeader";
import type { ResolvedHeaderColors } from "@/features/theme/resolveBrandedStyle";
import { TeamLogo } from "@/components/ui/TeamLogo";
import { PageNavigation } from "@/components/layout/PageNavigation";
import { OverviewTab } from "../tabs/OverviewTab/OverviewTab";
import { useTeamPageData } from "../context/TeamPageDataContext";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
const FixturesTab = dynamic(() => import("../tabs/FixturesTab/FixturesTab").then(mod => mod.FixturesTab));
const SquadTab = dynamic(() => import("../tabs/SquadTab/SquadTab").then(mod => mod.SquadTab));
const StatsTab = dynamic(() => import("../tabs/StatsTab/StatsTab").then(mod => mod.StatsTab));
const NewsTab = dynamic(() => import("../tabs/NewsTab/NewsTab").then(mod => mod.NewsTab));
const FansTab = dynamic(() => import("../tabs/FansTab/FansTab").then(mod => mod.FansTab));
const ClubTab = dynamic(() => import("../tabs/ClubTab/ClubTab").then(mod => mod.ClubTab));
const VideosTab = dynamic(() => import("../tabs/VideosTab/VideosTab").then(mod => mod.VideosTab));
type Tab = "overview" | "matches" | "squad" | "stats" | "club" | "news" | "videos" | "fans";
export function Team(t0) {
  const $ = _c(81);
  const {
    headerColors,
    breadcrumbs
  } = t0;
  const [activeTab, setActiveTab] = useState("overview");
  const {
    team,
    isSingleCompetition,
    hasAnyWikiPosts,
    hasAnyVideos
  } = useTeamPageData();
  const labels = useLabels().teamPage;
  const showFansTab = useTenantSettings().features.authentication.enabled;
  let t1;
  if ($[0] !== hasAnyWikiPosts) {
    t1 = hasAnyWikiPosts();
    $[0] = hasAnyWikiPosts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showClubTab = t1;
  let t2;
  if ($[2] !== hasAnyVideos) {
    t2 = hasAnyVideos();
    $[2] = hasAnyVideos;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const showVideosTab = t2;
  let t3;
  if ($[4] !== labels.tabs.overview) {
    t3 = {
      id: "overview",
      label: labels.tabs.overview
    };
    $[4] = labels.tabs.overview;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== labels.tabs.matches) {
    t4 = {
      id: "matches",
      label: labels.tabs.matches
    };
    $[6] = labels.tabs.matches;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== labels.tabs.squad) {
    t5 = {
      id: "squad",
      label: labels.tabs.squad
    };
    $[8] = labels.tabs.squad;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let baseTabs;
  if ($[10] !== isSingleCompetition || $[11] !== labels.tabs || $[12] !== showClubTab || $[13] !== showFansTab || $[14] !== showVideosTab || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    baseTabs = [t3, t4, t5];
    if (isSingleCompetition) {
      let t6;
      if ($[19] !== labels.tabs.stats) {
        t6 = {
          id: "stats",
          label: labels.tabs.stats
        };
        $[19] = labels.tabs.stats;
        $[20] = t6;
      } else {
        t6 = $[20];
      }
      baseTabs.push(t6);
    }
    if (showClubTab) {
      let t6;
      if ($[21] !== labels.tabs.club) {
        t6 = {
          id: "club",
          label: labels.tabs.club
        };
        $[21] = labels.tabs.club;
        $[22] = t6;
      } else {
        t6 = $[22];
      }
      baseTabs.push(t6);
    }
    let t6;
    if ($[23] !== labels.tabs.news) {
      t6 = {
        id: "news",
        label: labels.tabs.news
      };
      $[23] = labels.tabs.news;
      $[24] = t6;
    } else {
      t6 = $[24];
    }
    baseTabs.push(t6);
    if (showVideosTab) {
      const t7 = (labels.tabs as any).videos || "Videos";
      let t8;
      if ($[25] !== t7) {
        t8 = {
          id: "videos",
          label: t7
        };
        $[25] = t7;
        $[26] = t8;
      } else {
        t8 = $[26];
      }
      baseTabs.push(t8);
    }
    if (showFansTab) {
      let t7;
      if ($[27] !== labels.tabs.fans) {
        t7 = {
          id: "fans",
          label: labels.tabs.fans
        };
        $[27] = labels.tabs.fans;
        $[28] = t7;
      } else {
        t7 = $[28];
      }
      baseTabs.push(t7);
    }
    $[10] = isSingleCompetition;
    $[11] = labels.tabs;
    $[12] = showClubTab;
    $[13] = showFansTab;
    $[14] = showVideosTab;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = baseTabs;
  } else {
    baseTabs = $[18];
  }
  const tabs = baseTabs;
  let t6;
  let t7;
  if ($[29] !== tabs) {
    t6 = () => {
      const hash = window.location.hash.slice(1) as Tab;
      if (hash && tabs.some(tab => tab.id === hash)) {
        setActiveTab(hash);
      }
    };
    t7 = [tabs];
    $[29] = tabs;
    $[30] = t6;
    $[31] = t7;
  } else {
    t6 = $[30];
    t7 = $[31];
  }
  useEffect(t6, t7);
  let t8;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = tabId => {
      setActiveTab(tabId);
      window.history.pushState(null, "", `#${tabId}`);
    };
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  const handleTabChange = t8;
  const t9 = team.nickname || team.shortName || "";
  const t10 = team.assets?.logo;
  const t11 = team.assets?.logo;
  const t12 = team.country?.code;
  const t13 = team.country?.flag;
  const t14 = team.metadata?.branding?.primaryColor;
  const t15 = team.metadata?.branding?.secondaryColor;
  let t16;
  if ($[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
    t16 = <TeamLogo src={t11} size="xl2" countryCode={t12} countryFlag={t13} primaryColor={t14} secondaryColor={t15} />;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const t17 = headerColors?.colors;
  const t18 = headerColors?.backgroundImageUrl;
  let t19;
  if ($[39] !== breadcrumbs || $[40] !== t10 || $[41] !== t16 || $[42] !== t17 || $[43] !== t18 || $[44] !== t9 || $[45] !== team.name) {
    t19 = <BrandedHeader titleAs="h1" title={team.name} subtitle={t9} imageUrl={t10} image={t16} colors={t17} backgroundImageUrl={t18} breadcrumbs={breadcrumbs} />;
    $[39] = breadcrumbs;
    $[40] = t10;
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
    $[44] = t9;
    $[45] = team.name;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== activeTab || $[48] !== tabs) {
    t20 = <PageNavigation options={tabs} activeId={activeTab} onChange={handleTabChange} sticky={true} />;
    $[47] = activeTab;
    $[48] = tabs;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== activeTab) {
    t21 = activeTab === "overview" && <OverviewTab onNavigateToSquad={() => handleTabChange("squad")} />;
    $[50] = activeTab;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== activeTab) {
    t22 = activeTab === "matches" && <FixturesTab />;
    $[52] = activeTab;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== activeTab) {
    t23 = activeTab === "squad" && <SquadTab />;
    $[54] = activeTab;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== activeTab || $[57] !== isSingleCompetition) {
    t24 = activeTab === "stats" && isSingleCompetition && <StatsTab />;
    $[56] = activeTab;
    $[57] = isSingleCompetition;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== activeTab) {
    t25 = activeTab === "club" && <ClubTab />;
    $[59] = activeTab;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== activeTab) {
    t26 = activeTab === "news" && <NewsTab />;
    $[61] = activeTab;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== activeTab) {
    t27 = activeTab === "videos" && <VideosTab />;
    $[63] = activeTab;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== activeTab || $[66] !== showFansTab) {
    t28 = activeTab === "fans" && showFansTab && <FansTab />;
    $[65] = activeTab;
    $[66] = showFansTab;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t21 || $[69] !== t22 || $[70] !== t23 || $[71] !== t24 || $[72] !== t25 || $[73] !== t26 || $[74] !== t27 || $[75] !== t28) {
    t29 = <div className="max-w-350 mx-auto px-4 py-8">{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t28}</div>;
    $[68] = t21;
    $[69] = t22;
    $[70] = t23;
    $[71] = t24;
    $[72] = t25;
    $[73] = t26;
    $[74] = t27;
    $[75] = t28;
    $[76] = t29;
  } else {
    t29 = $[76];
  }
  let t30;
  if ($[77] !== t19 || $[78] !== t20 || $[79] !== t29) {
    t30 = <div className="min-h-screen">{t19}{t20}{t29}</div>;
    $[77] = t19;
    $[78] = t20;
    $[79] = t29;
    $[80] = t30;
  } else {
    t30 = $[80];
  }
  return t30;
}